document.addEventListener("DOMContentLoaded", function() {

  const steps = document.querySelectorAll('.questionnaire__question');
  const breadcrumbSteps = document.querySelectorAll('.questionnaire__breadcrumb span');
  let currentStep = 0;
  let questionnaireAnswers = [];
  let userEmail = '';

  function addOrUpdateAnswer(name, value) {
    const existingAnswer = questionnaireAnswers.find(item => item[name] !== undefined);
    if (existingAnswer) {
      existingAnswer[name] = value; // Utilise `existingAnswer[name]` pour modifier la valeur
    } else {
      questionnaireAnswers.push({ [name]: value });
    }
  }

  // Stocker les données dans le localStorage
  function storeData(stepIndex) {
    const selectedRadio = steps[stepIndex].querySelector('input[type="radio"]:checked');
    if (selectedRadio) {
      localStorage.setItem(selectedRadio.name, selectedRadio.value);

      addOrUpdateAnswer(selectedRadio.name, selectedRadio.value);
      localStorage.setItem('questionnaireData', JSON.stringify(questionnaireAnswers));
    }
  }

  // Charger les données du localStorage au démarrage
  function loadStoredData() {

    const storedData = localStorage.getItem('questionnaireData');
    if (storedData) {
      questionnaireAnswers = JSON.parse(storedData);
    }

    steps.forEach((step) => {
      const radios = step.querySelectorAll('input[type="radio"]');
      radios.forEach(radio => {
        const storedValue = localStorage.getItem(radio.name);
        if (storedValue && radio.value === storedValue) {
          radio.checked = true;
        }
      });
    });
  }

  loadStoredData();

  function showStep(stepIndex) {
    steps.forEach((step, index) => {
      step.classList.remove('step_active');
      if (index === stepIndex) {
        step.classList.add('step_active');
      }
    });
  }

  function changeBreadcrumb(stepIndex) {
    breadcrumbSteps.forEach((step, index) => {
      if (index === stepIndex) {
        step.classList.add('done');
      }
      if (index > stepIndex) {
        step.classList.remove('done');
      }
    });
  }

  function processAnswers() {
    const storedData = localStorage.getItem('questionnaireData');
    const AllDataArray = {};
    const reponsesFormatees = {};

    if (storedData) {
      const dataArray = JSON.parse(storedData);
      dataArray.forEach((item, index) => {
        for (const key in item) {
          AllDataArray[key] = item[key];
          const formattedKey = `Reponse_Question_${index + 1}`;
          reponsesFormatees[formattedKey] = item[key];
        }
      });

      let slug = '';

      if (AllDataArray['Type_Utilisateur'] === "C'est pour un enfant") {
        slug = 'oreiller-enfant';
      } else if (AllDataArray['Probleme_Cervicales'] === "Non, ou que très rarement") {
        switch (AllDataArray['Fermete_Appreciee']) {
          case 'Souple':
            slug = 'apollon';
            break;
          case 'Mi-Ferme':
            slug = 'aceso';
            break;
          case 'Ferme':
            slug = 'athena';
            break;
        }
      } else {
        const type = AllDataArray['Type_Utilisateur'];
        const carrure = AllDataArray['Carrure_Utilisateur'];
        const fermete = AllDataArray['Fermete_Appreciee'];
        const position = AllDataArray['Position_de_sommeil'];

        if (type === "Un homme") {
          if (carrure === "XS-S") {
            if (fermete === "Souple") {
              slug = position === 'Sur le ventre' ? 'epione' : 'oreiller-asclepios';
            } else if (fermete === "Mi-Ferme") {
              slug = position === 'Sur le ventre' ? 'oreiller-eros' : 'oreiller-morphee';
            } else if (fermete === "Ferme") {
              slug = 'oreiller-eros';
            }
          } else if (carrure === "M-L") {
            if (fermete === "Souple") {
              slug = 'oreiller-morphee';
            } else if (fermete === "Mi-Ferme") {
              if (position === 'Sur le dos') slug = 'oreiller-morphee';
              else if (position === 'Sur le côté') slug = 'le-morphee';
              else slug = 'oreiller-eros';
            } else if (fermete === "Ferme") {
              slug = position === 'Sur le ventre' ? 'oreiller-eros' : 'le-morphee';
            }
          } else if (carrure === "XL-XXL") {
            if (fermete === "Souple") {
              slug = 'oreiller-morphee';
            } else if (fermete === "Mi-Ferme") {
              slug = 'le-morphee';
            } else if (fermete === "Ferme") {
              slug = position === 'Sur le ventre' ? 'le-morphee' : 'oreiller-hygie';
            }
          }
        }

        if (type === "Une femme") {
          if (carrure === "XS-S") {
            if (fermete === "Souple") {
              slug = position === 'Sur le ventre' ? 'epione' : 'oreiller-asclepios';
            } else if (fermete === "Mi-Ferme") {
              slug = 'oreiller-morphee';
            } else if (fermete === "Ferme") {
              slug = 'oreiller-eros';
            }
          } else if (carrure === "M-L") {
            if (fermete === "Souple") {
              if (position === 'Sur le ventre' || position === 'Sur le dos') {
                slug = 'oreiller-morphee';
              } else {
                slug = 'oreiller-asclepios';
              }
            } else if (fermete === "Mi-Ferme") {
              slug = position === 'Sur le ventre' ? 'oreiller-eros' : 'oreiller-morphee';
            } else if (fermete === "Ferme") {
              slug = position === 'Sur le ventre' ? 'oreiller-eros' : 'le-morphee';
            }
          } else if (carrure === "XL-XXL") {
            if (fermete === "Souple") {
              slug = 'oreiller-morphee';
            } else if (fermete === "Mi-Ferme") {
              slug = 'le-morphee';
            } else if (fermete === "Ferme") {
              slug = position === 'Sur le ventre' ? 'le-morphee' : 'oreiller-hygie';
            }
          }
        }
      }

      if (slug) {
        if (userEmail) {
          envoyerEvenementKlaviyo(userEmail, slug, reponsesFormatees);
        }
        window.location.href = `/pages/resultat-questionnaire?product=${slug}`;
      } else {
        console.warn("Aucun produit recommandé – données incomplètes ou non reconnues");
      }
    }
  }


  function envoyerEvenementKlaviyo(email, produitSlug, reponses) {
    const klaviyoPublicApiKey = 'NtcgjF';

    const nomProduit = produitSlug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

    const cheminReponses = Object.keys(reponses)
      .filter(key => key.startsWith('Reponse_Question_'))
      .sort() // Assure l'ordre 1, 2, 3...
      .map(key => reponses[key])
      .filter(Boolean)
      .concat(nomProduit)
      .join(' - ');

    const payload = {
      token: klaviyoPublicApiKey,
      event: 'Test Oreiller Terminé',
      customer_properties: {
        $email: email,
        Reponse_Oreiller: nomProduit,
        Reponse_Chemin: cheminReponses,
        ...reponses
      },
      properties: {
        $email: email,
        Reponse_Oreiller: nomProduit,
        Reponse_Chemin: cheminReponses,
        ...reponses
      }
    };

    const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    const img = new Image();
    img.src = `https://a.klaviyo.com/api/track?data=${base64Payload}`;

    console.log('Événement Klaviyo envoyé via pixel', img.src);

    mettreAJourProfilKlaviyo(email, nomProduit, reponses, cheminReponses);
  }

  function mettreAJourProfilKlaviyo(email, nomProduit, reponses, cheminReponses) {
    const klaviyoPublicApiKey = 'NtcgjF';

    const payload = {
      token: klaviyoPublicApiKey,
      properties: {
        $email: email,
        Reponse_Oreiller: nomProduit,
        Reponse_Chemin: cheminReponses,
        ...reponses
      }
    };

    const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
    const img = new Image();
    img.src = `https://a.klaviyo.com/api/identify?data=${base64Payload}`;

    console.log('Profil Klaviyo mis à jour via pixel', img.src);
  }


  // Gestion du clic sur les labels pour passer à l'étape suivante
  document.querySelectorAll('.questionnaire__answer label').forEach(label => {
    label.addEventListener('click', () => {
      setTimeout(() => {
        document.querySelector('.questionnaire__actions .button--next').click();
      }, 0);
    });
  });

  // Bouton retour
  document.querySelectorAll('.questionnaire__actions .button--back').forEach(button => {
    button.addEventListener('click', () => {
      if (currentStep > 0) {
        currentStep--;
        if (currentStep == 0) {
          document.querySelector('.questionnaire__actions').style.display = "none";
        }
        showStep(currentStep);
        changeBreadcrumb(currentStep);
      }
    });
  });

  // Bouton suivant
  document.querySelectorAll('.questionnaire__actions .button--next').forEach(button => {
    button.addEventListener('click', () => {
      if (currentStep < steps.length - 1) {
        if (currentStep == 0) {
          document.querySelector('.questionnaire__actions').style.display = "inline-flex";
        }
        storeData(currentStep);
        currentStep++;
        showStep(currentStep);
        changeBreadcrumb(currentStep);
      }
      if (currentStep == steps.length - 1) {
        // LAST STEP
        document.querySelector('.questionnaire__actions').style.display = "none";
        setTimeout(() => {
          processAnswers();
        }, 3000);

      }
    });
  });

  const emailButton = document.getElementById('validateEmailButton');
  if (emailButton) {
    emailButton.addEventListener('click', () => {
      const emailInput = document.getElementById('userEmail');
      const email = emailInput.value.trim();
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (email) {
        if (emailRegex.test(email)) {
          userEmail = email;
        } else {
          alert("Veuillez entrer une adresse email valide.");
          return;
        }
      }
      document.querySelector('.questionnaire__actions .button--next').click();
    });
  }
});
